import { RTM } from "@/qrtc_web_rtm/rtm";
import isElectron from "is-electron";

export const ENVSETTINGKEY = "thisisenvsettingkey";
export const TIMEOUT = 20000;
export const CONTENTTYPE = "application/json;charset=UTF-8";
export const APKNAME = "suhang-meeting-latest.apk";

export const WebLinkStatus="WebLinkStatus"
// 登录后用户信息
export const LOGININFOSTORE = "thisisankeytosavelogininfo";
// 登录后用户Token
export const LOGINTOKEN = "thisisanlocastoragetosavelogintoken";
// 设置的key
export const NORMALSETTINGKEY = "thisisthekeyforsavenormalsettings";
// 当前进入的会议信息
export const METTINGPAGE_SAVED_MEETING_INFO = "thisisakeyforsavemeetinginfo";

export const RTM_APPID = "yourappid";
export const RTM_TOKEN = "yourtoken";
//export const RTM_SERVERURL = "ws://49.232.122.245:8002/";
export const RTM_PUBROOM = "10000000000";
export var CurrParticipant= "" ;
export const SVR_DOMAIN = "https://www.superrtc.com"; // 100ms 良好， 300毫秒 较差,  其他，不正常
export const BAIDU = "https://www.baidu.com";
export const GOOG = "https://www.google.com";

const env = window.localStorage.getItem(ENVSETTINGKEY) || "online";
const istest = env === "test"; // || process.env.NODE_ENV === "development";
let devMode = window.location.hostname.indexOf('localhost') != -1
 //从浏览器端动态获取ip
let mycurrip= window.location.hostname;
const ELECTRON_BASEURL = `https://www.superrtc.com/meetingapi`;
const ELECTRON_WSSERVER = `wss://www.superrtc.com/websocket/`
const ELECTRON_QUIC_SERVER = `https://www.superrtc.com/webtransport/`

const lanTest/*内网测试模式*/ = false;
let lanTestServer = "192.168.31.184"
let testServer = "192.168.31.184" //121.36.0.230
//let testServer = "124.71.218.21" // 南大地址

let onlineServer = "192.168.31.184"

const protocol = window.location.protocol;
const hostname = window.location.hostname;
const port = window.location.port;
const origin = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
const hostWithPort = `${hostname}${port ? `:${port}` : ''}`;
const runtimeEnv = process.env as Record<string, string | undefined>;
const envValue = (...names: string[]) =>
  names.map((name) => runtimeEnv[name]).find((value) => typeof value === "string" && value.length > 0);

function getWebBaseUrl() {
   
  if (istest/*测试模式*/) {
    if (devMode) {
      return lanTest?`http://${lanTestServer}:8200` : `http://${testServer}:8200`;
    } else {
      return `${origin}/meetingapi`;
    }
  } else/*正式模式*/ {
    if (devMode) {
      return lanTest?`http://${lanTestServer}:8200` : `http://${onlineServer}:8200`;
    } else {
      return `${origin}/meetingapi`
    }
  }
}

function getWebWssServer(){
  if (istest/*测试模式*/) {
    if (devMode) {
      return lanTest?`ws://${lanTestServer}:8001/` : `ws://${testServer}:8001/`;
    } else {
      return `wss://${hostWithPort}/websocket/`;
    }
  } else/*正式模式*/ {
    if (devMode) {
      return lanTest?`ws://${lanTestServer}:8001/` : `ws://${onlineServer}:8001/`;
    } else {
      return `wss://${hostWithPort}/websocket/`
    }
  }
 }

function getWebQuicServer(){
  if (istest/*测试模式*/) {
    if (devMode) {
      return lanTest?`https://${lanTestServer}:443/webtransport/` : `https://${testServer}:443/webtransport/`;
    } else {
      return `https://${hostWithPort}/webtransport/`;
    }
  } else/*正式模式*/ {
    if (devMode) {
      return lanTest?`https://${lanTestServer}:443/webtransport/` : `https://${onlineServer}:443/webtransport/`;
    } else {
      return `https://${hostWithPort}/webtransport/`
    }
  }
 }

 function getRTMServer(){
  if (istest/*测试模式*/) {
    if (devMode) {
      return lanTest?`ws://${lanTestServer}:8002/` : `ws://${testServer}:8002/`;
    } else {
      return `wss://${hostWithPort}/rtm/`;
    }
  } else/*正式模式*/ {
    if (devMode) {
      return lanTest?`ws://${lanTestServer}:8002/` : `ws://${onlineServer}:8002/`;
    } else {
      return `wss://${hostWithPort}/rtm/`
    }
  }
 }

 function getAiRTMServer(){
  const scheme = window.location.protocol === "https:" ? "wss" : "ws";
  if (istest/*测试模式*/) {
    if (devMode) {
      return lanTest?`${scheme}://${lanTestServer}:8021/` : `${scheme}://${testServer}:8021/`;
    } else {
      return `${scheme}://${hostname}:8021/`;
    }
  } else/*正式模式*/ {
    if (devMode) {
      return lanTest?`${scheme}://${lanTestServer}:8021/` : `${scheme}://${onlineServer}:8021/`;
    } else {
      return `${scheme}://${hostname}:8021/`;
    }
  }
 }

function getBaseUrl(){
  return isElectron() ? ELECTRON_BASEURL:getWebBaseUrl();
}

function getWssServer(){
  return isElectron() ? ELECTRON_WSSERVER:getWebWssServer();
}

function getQuicServer(){
  return isElectron() ? ELECTRON_QUIC_SERVER:getWebQuicServer();
}


// const WEB_BASEURL = istest
//   ? (devMode ? "http://121.36.0.230:8200":`${window.location.origin}/restful4`)
//   : (devMode ? 'http://49.232.122.245:8200':`${window.location.origin}/restful3`);
export const BASEURL = getBaseUrl();
// const WEB_WSSSERVER = istest
// ? (devMode ? 'ws://121.36.0.230:8001/':`wss://${window.location.hostname}/websocket4/`)
// : (devMode ? 'ws://49.232.122.245:8001/':`wss://${window.location.hostname}/websocket3/`);
export const WSSSERVER = getWssServer();
export const RTC_SIGNAL_PROTOCOL =
  (envValue("REACT_APP_RTC_SIGNAL_PROTOCOL", "VITE_RTC_SIGNAL_PROTOCOL") as 'websocket' | 'quic' | 'auto' | undefined) || 'websocket';
export const RTC_QUIC_SERVERURL = envValue("REACT_APP_RTC_QUIC_URL", "VITE_RTC_QUIC_URL") || getQuicServer();
export const RTC_QUIC_PATH = envValue("REACT_APP_RTC_QUIC_PATH", "VITE_RTC_QUIC_PATH") || '/webtransport/';
export const RTC_QUIC_CERT_SHA256 = envValue("REACT_APP_RTC_QUIC_CERT_SHA256", "VITE_RTC_QUIC_CERT_SHA256") || '';
export const RTC_FALLBACK_WEBSOCKET = envValue("REACT_APP_RTC_FALLBACK_WEBSOCKET", "VITE_RTC_FALLBACK_WEBSOCKET") !== 'false';
export const RTC_VIDEO_CODEC = envValue("REACT_APP_RTC_VIDEO_CODEC", "VITE_RTC_VIDEO_CODEC") || 'h264';

export const RTM_SERVERURL = getRTMServer();
export const AI_RTM_SERVERURL = getAiRTMServer();

console.log(`server=BaseUrl=${BASEURL} WssServer=${WSSSERVER} RTM_SERVERURL=${RTM_SERVERURL} AI_RTM_SERVERURL=${AI_RTM_SERVERURL} RTC_SIGNAL_PROTOCOL=${RTC_SIGNAL_PROTOCOL} RTC_QUIC_SERVERURL=${RTC_QUIC_SERVERURL} RTC_VIDEO_CODEC=${RTC_VIDEO_CODEC}`);

export const RECORD_SERVER = istest?`http://${testServer}:8019/`:`http://${window.location.hostname}:8019/`;

export const SVR_URL = istest
  ? `https://${testServer}:8001`
  : `https://${testServer}:8001`;

export const CURRENT_VERSION = "20251225-7";

//18611385915 //123456
// 832/562
